import styled from 'styled-components';

const ArrowSvg = styled.svg`
	position: absolute;
	width: 400px;
	margin: -10px -200px;
	pointer-events: none;

	path,
	polyline {
		stroke: ${(props) => props.theme.colors.lightBlueDark};
	}
`;

export default function RoleEdge(props: {
	from: [number, number];
	to: [number, number];
	bend?: 'in' | 'out';
	dashed?: boolean;
}) {
	const [sx, sy] = props.from;
	const [x, y] = props.to;

	return (
		<ArrowSvg style={{ marginTop: sy - 10, height: y - sy + 20 }}>
			<defs>
				<marker
					id="arrow"
					markerWidth={20}
					markerHeight={20}
					refX="10"
					refY="10"
					orient="auto"
					markerUnits="userSpaceOnUse"
				>
					<polyline points="0 0, 10 10, 0 20" fill="transparent" strokeWidth={2} />
				</marker>
			</defs>
			<path
				d={[
					`M ${200 + sx} 10`,
					props.bend === 'out'
						? `Q ${200 + sx} ${((y - sy) / 4) * 3 + 10}`
						: `Q ${200 + x} ${(y - sy) / 4 + 10}`,
					`${200 + x} ${y - sy + 10}`,
				].join(' ')}
				fill="transparent"
				strokeWidth={2}
				strokeDasharray={props.dashed ? '4 4' : undefined}
				markerEnd={props.dashed ? undefined : 'url(#arrow)'}
			/>
		</ArrowSvg>
	);
}
